import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = { auth: true }

export default {
    path: '/shop',
    name: 'shop',
    meta,
    redirect: { name: 'shop' },
    component: layoutHeaderAside,
    children: (pre => [
        {
            path: 'shopList',
            name: `${pre}shopList`,
            component: _import('shop/shopList'),
            meta: {
                ...meta,
                title: '店铺列表'
            }
        },
		{
		    path: 'shopBannerList',
		    name: `${pre}shopBannerList`,
		    component: _import('shop/shopBannerList'),
		    meta: {
		        ...meta,
		        title: '店铺广告图'
		    }
		},
        {
            path: 'shopCashierList',
            name: `${pre}shopCashierList`,
            component: _import('shop/shopCashierList'),
            meta: {
                ...meta,
                title: '收银员列表'
            }
        },
        {
            path: 'shopAccountList',
            name: `${pre}shopAccountList`,
            component: _import('shop/shopAccountList'),
            meta: {
                ...meta,
                title: '绑定账号列表'
            }
        }
    ])('shop-')
}
